const { vi } = require('date-fns/locale');
const {
  format: dformat,
  formatDistance: dformatDistance,
  formatDistanceStrict: dformatDistanceStrict,
  formatDistanceToNow: dformatDistanceToNow,
  formatDistanceToNowStrict: dformatDistanceToNowStrict,
  parse: dparse,
  isMatch: disMatch,
  isEqual,
  add,
  closestIndexTo,
  closestTo,
  compareAsc,
  compareDesc,
  min,
  max,
  set,
  sub,
  isSameDay,
  startOfDay,
  startOfMonth,
  endOfWeek,
  startOfWeek,
  addDays,
  getDaysInMonth,
  parseISO,
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInMonths,
  differenceInCalendarYears,
  isValid,
  differenceInMilliseconds,
  endOfDay,
  getHours,
  setHours,
  setMinutes,
  getSeconds,
  setSeconds,
  isSameMonth,
  isSameYear,
  isSameHour,
  endOfMonth,
  getYear,
  startOfYear,
  setYear,
  endOfYear,
  setMonth,
  addMonths,
  addYears,
  getWeekOfMonth,
} = require('date-fns');

const MONTHS = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  vi: [...Array(12).keys()].map((i) => `Tháng ${i + 1}`),
};
const FIRST_DAY = {
  en: 0,
  vi: 1,
};
const WEEKDAYS_SHORT = {
  en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  vi: ['CN', 'HAI', 'BA', 'TƯ', 'NĂM', 'SÁU', 'BẢY'],
};
const WEEKDAYS_LONG = {
  en: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  vi: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
};

const locale = vi;
const weekStartsOn = 1;
const firstWeekContainsDate = 1;
const useAdditionalWeekYearTokens = false;
const useAdditionalDayOfYearTokens = false;
const addSuffix = false;
const roundingMethod = 'round';
const includeSeconds = false;

const localeUtils = {
  formatDay: function (d, locale = 'vi') {
    const weekdaysLong = WEEKDAYS_LONG[locale][d.getDay()];
    return `${weekdaysLong}, ${d.getDate()} ${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
  },
  formatMonthTitle: function (d, locale = 'vi') {
    return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
  },
  formatWeekdayShort: function (i, locale = 'vi') {
    return WEEKDAYS_SHORT[locale][i];
  },
  formatWeekdayLong: function (i, locale = 'vi') {
    return WEEKDAYS_SHORT[locale][i];
  },
  getFirstDayOfWeek: function (locale = vi) {
    return FIRST_DAY[locale];
  }
};

function format(date, formatStr = 'dd/MM/y', options = {}) {
  if (date) {
    return dformat(date, formatStr, {
      locale,
      weekStartsOn,
      firstWeekContainsDate,
      useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens,
      ...options,
    });
  }
  return '';
};

function formatDistance(date, baseDate, options = {}) {
  if (date) {
    return dformatDistance(date, baseDate, {
      addSuffix,
      roundingMethod,
      locale,
      ...options,
    });
  }
  return '';
};

function formatDistanceStrict(date, baseDate, options = {}) {
  if (date) {
    return dformatDistanceStrict(date, baseDate, {
      addSuffix,
      roundingMethod,
      locale,
      ...options,
    });
  }
  return '';
};

function formatDistanceToNow(date, options = {}) {
  if (date) {
    return dformatDistanceToNow(date, {
      includeSeconds,
      addSuffix,
      locale,
      ...options,
    });
  }
  return '';
};

function formatDistanceToNowStrict(date, options = {}) {
  if (date) {
    return dformatDistanceToNowStrict(date, {
      includeSeconds,
      addSuffix,
      locale,
      ...options,
    });
  }
  return '';
}

function parse(dateStr, formatStr = 'dd/MM/y', refDate = new Date(), options = {}) {
  return dparse(
    dateStr,
    formatStr,
    refDate,
    {
      locale,
      weekStartsOn,
      firstWeekContainsDate,
      useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens,
      ...options,
    },
  );
}

function isMatch(date, formatStr = 'dd/MM/y', options = {}) {
  return disMatch(date, formatStr, {
    locale,
    weekStartsOn,
    firstWeekContainsDate,
    useAdditionalDayOfYearTokens,
    useAdditionalWeekYearTokens,
    ...options,
  });
}

const objectIdFromDate = (date) => `${Math.floor(date.getTime() / 1000).toString(16)}0000000000000000`;

const dateFromObjectId = (objectId) => new Date(
  parseInt(`${objectId}`.substring(0, 8), 16) * 1000,
).getTime();

module.exports = {
  localeUtils,
  format,
  formatDistance,
  formatDistanceStrict,
  formatDistanceToNow,
  formatDistanceToNowStrict,
  isEqual,
  parse,
  isMatch,
  min,
  max,
  add,
  closestIndexTo,
  closestTo,
  compareAsc,
  compareDesc,
  set,
  sub,
  isSameDay,
  startOfDay,
  startOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  getDaysInMonth,
  parseISO,
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInMonths,
  differenceInCalendarYears,
  objectIdFromDate,
  dateFromObjectId,
  isValid,
  differenceInMilliseconds,
  endOfDay,
  getHours,
  setHours,
  setMinutes,
  getSeconds,
  setSeconds,
  isSameMonth,
  isSameYear,
  isSameHour,
  endOfMonth,
  setYear,
  getYear,
  startOfYear,
  endOfYear,
  addMonths,
  setMonth,
  addYears,
  getWeekOfMonth,
};
